import { Button } from 'components/Button'
import Styles from './InsertHandle.module.scss'
import { ReactComponent as PlusIcon } from 'assets/icons/plus16.svg'
import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'
import { insertAIPrompt } from '../../AIInlinePrompt/utils'

export function InsertHandle({ getPos }: { getPos: () => number | undefined }) {
  const view = useEditorView()

  return (
    <div>
      <Button
        preventFocusOnPress
        variant="tertiary"
        size="md"
        frontIcon={PlusIcon}
        className={Styles.plusButton}
        onPress={() => insertAIPrompt(view, getPos)}
      />
    </div>
  )
}
